export const firebase_config = {
    apiKey: "AIzaSyCcjGxVNnYoElnZyDWliT0NamtM5viXm7U",
    authDomain: "pinoy-marketplace.firebaseapp.com",
    databaseURL: "https://pinoy-marketplace.firebaseio.com",
    projectId: "pinoy-marketplace",
    storageBucket: "pinoy-marketplace.appspot.com",
    messagingSenderId: "382928256196",
    appId: "1:382928256196:web:4c50b95c2f70b020a35d91",
    measurementId: "G-P5T762JRBQ"
};